import { render, staticRenderFns } from "./CampaignPagesContainer.vue?vue&type=template&id=738f5413&"
import script from "./CampaignPagesContainer.vue?vue&type=script&lang=js&"
export * from "./CampaignPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports